// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Loader_componentWrapper__ENZgV","spinner":"Loader_spinner__M1nw9"};